import { LoadingButton, LoadingButtonProps } from '@mui/lab';
import { styled } from '@mui/material/styles';

const CustomButton = styled(LoadingButton)<LoadingButtonProps>(
  ({ color = 'secondary', theme }) => ({
    color: (theme.palette as any)[color].contrastText || '#fff',
    fontFamily: 'Lexend Exa, sans-serif',
    background: (theme.palette as any)[color].main || '#fff',
    boxShadow: '2px 2px 0px var(--buttonShadow)',
    padding: '4px 16px',
    border: '1px solid var(--PURPLE)',
    borderRadius: '0px',
    height: '32px',
    textTransform: 'none',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: '600',
    fontStyle: 'normal',
    '&:hover': {
      backgroundColor: (theme.palette as any)[color].light || '#DCEEEF',
    },
    '&:disabled': {
      cursor: 'progress',
    },
  }),
);

export default CustomButton;
